import { useStyletron } from 'baseui';
import { Block } from 'baseui/block';
import { ObjectAlarms } from '../../../features/Alarm/ObjectAlarms';
import { ChildrenView } from '../ChildrenView';
import { StyledDivider } from 'baseui/divider';


export type OperatorPanelContainerProps = {
    objectId: string,
    resourceGroupId: string,
    statusContent: React.ReactNode,
    operationModeContent?: React.ReactNode,
    additionalContent?: React.ReactNode,
    children?: any,
    width?: any,
    filter?: (app: any) => boolean | undefined,
}

export const OperatorPanelWrapper = (props: OperatorPanelContainerProps) => {
    const [css, theme] = useStyletron();
    return (
        <Block width='300px' alignItems='center' flexDirection='column' display='flex' gridGap={theme.sizing.scale800}  >
            <ObjectAlarms resourceGroupId={props.resourceGroupId} id={props.objectId} />
            {props.statusContent}
            {props.operationModeContent}
            {props.additionalContent}
            {props.children && <div className={css({ width: '100%' })}><StyledDivider $size='cell'></StyledDivider></div>}
            {props.children}
        </Block>
    )
}
export const OperatorPanelWrapperFullSize = (props: OperatorPanelContainerProps) => {
    const [css, theme] = useStyletron();
    return (
        <Block width='98%' alignItems='center' flexDirection='column' display='flex' gridGap={theme.sizing.scale800}  >
            <ObjectAlarms resourceGroupId={props.resourceGroupId} id={props.objectId} />
            {props.statusContent}
            {props.operationModeContent}
            {props.additionalContent}
            {props.children && <div className={css({ width: '100%' })}><StyledDivider $size='cell'></StyledDivider></div>}
            {props.children}
        </Block>
    )
}
export const OperatorPanelWrapperNoAlarm = (props: OperatorPanelContainerProps) => {
    const [css, theme] = useStyletron();
    return (
        <Block width='300px' alignItems='center' flexDirection='column' display='flex' gridGap={theme.sizing.scale800}  >
            {props.statusContent}
            {props.operationModeContent}
            {props.additionalContent}
            {props.children && <div className={css({ width: '100%' })}><StyledDivider $size='cell'></StyledDivider></div>}
            {props.children}
        </Block>
    )
}


export const OperatorPanelWrapperWithChildren = (props: OperatorPanelContainerProps) => {
    const [css, theme] = useStyletron();
    return (
        <>
            <Block alignItems='flex-start' flexDirection='column' display='flex' gridGap={theme.sizing.scale800} >
                <Block width={props.width ?? '300px'} alignItems='center' flexDirection='column' display='flex' gridGap={theme.sizing.scale800}  >
                    <ObjectAlarms resourceGroupId={props.resourceGroupId} id={props.objectId} />
                    {props.statusContent}
                    {props.operationModeContent}
                    {props.additionalContent}
                </Block>
                <div className={css({ width: '100%' })}>
                    <StyledDivider $size='cell'></StyledDivider>
                    <ChildrenView filter={props.filter} resourceGroupId={props.resourceGroupId} parentId={props.objectId} />
                </div>
            </Block>
        </>
    )
}